export { default as VerifyResetPassword } from './verify-reset-password';
